export const menuItems = [
    {
        id: 2,
        label: 'menuitems.dashboard.text',
        icon: 'ri-dashboard-line',
        link: '/'
    },
    {
        id: 5,
        label: 'menuitems.campaign.text',
        role: ['campaign.view', 'prize.view', 'return_prize.view'],
        icon: 'ri-bard-line',
        subItems: [
            {
                id: 6,
                label: 'menuitems.campaign.list.text',
                role: ['campaign.view', 'campaign.register', 'document.export', 'partner_request_sheet.view'],
                link: '/',
                subItems: [
                    {
                        id: 7,
                        label: 'menuitems.campaign.list.list',
                        link: '/campaign/list',
                        role: 'campaign.view'
                    },
                    {
                        id: 8,
                        label: 'menuitems.campaign.list.create',
                        link: '/campaign/form',
                        role: 'campaign.register'
                    },
                    {
                        id: 9,
                        label: 'menuitems.campaign.list.document',
                        link: '/documents',
                        role: 'document.export'
                    },
                    {
                        id: 10,
                        label: 'menuitems.campaign.list.requestSheetPartner',
                        link: '/require',
                        role: 'partner_request_sheet.view'
                    }
                ]
            },
            {
                id: 9,
                label: 'menuitems.gift.text',
                role: 'prize.view',
                link: '/',
                subItems: [
                    {
                        id: 10,
                        label: 'menuitems.gift.list.list',
                        link: '/prize/list',
                        role: 'prize.view'
                    }
                ]
            },
            {
                id: 32,
                label: 'menuitems.returnGift.text',
                role: ['return_prize.view', 'return_prize.register'],
                link: '/',
                subItems: [
                    {
                        id: 33,
                        label: 'menuitems.gift.list.list',
                        link: '/prize-return/list',
                        role: 'return_prize.view'
                    },
                    {
                        id: 34,
                        label: 'menuitems.gift.list.create',
                        link: '/prize-return/form',
                        role: 'return_prize.register'
                    }
                ]
            }
        ]
    },
    {
        id: 110,
        label: 'menuitems.landingPage.text',
        role: ['landing_page.view', 'landing_page.register'],
        icon: 'ri-layout-3-line',
        subItems: [
            {
                id: 111,
                label: 'menuitems.landingPage.list',
                role: 'landing_page.view',
                link: '/landing-page/list'
            },
            {
                id: 112,
                label: 'menuitems.landingPage.create',
                link: '/landing-page/create',
                role: 'landing_page.register'
            },
            {
                id: 113,
                label: 'menuitems.landingPage.createUpload',
                link: '/landing-page/create-upload',
                role: 'landing_page.register'
            }
        ]
    },
    {
        id: 100,
        label: 'menuitems.managerForm.text',
        role: ['form.view', 'form.register', 'form.setting_mail'],
        icon: 'ri-pages-line',
        subItems: [
            {
                id: 101,
                label: 'menuitems.managerForm.list',
                role: 'form.view',
                link: '/manager-form/list'
            },
            {
                id: 102,
                label: 'menuitems.managerForm.create',
                link: '/manager-form/create',
                role: 'form.register'
            },
            {
                id: 103,
                label: 'menuitems.managerForm.settingEmail',
                link: '/manager-form/email',
                role: 'form.setting_mail'
            }
        ]
    },
    {
        id: 12,
        label: 'menuitems.master.text',
        role: [
            'client.view',
            'partner.view',
            'employee.view',
            'permission.view',
            'faq.view',
            'master.register',
            'master.edit',
            'master.delete',
            'master.view'
        ],
        icon: 'ri-account-circle-line',
        subItems: [
            {
                id: 33,
                label: 'menuitems.master.userMaster',
                role: ['client.view', 'partner.view', 'employee.view', 'client.register', 'partner.register', 'employee.register'],
                subItems: [
                    {
                        id: 13,
                        label: 'menuitems.master.customer.text',
                        role: ['client.view', 'client.register'],
                        link: '/',
                        color: '#34a853',
                        bg_active: '#34a85380',
                        subItems: [
                            {
                                id: 14,
                                label: 'menuitems.master.customer.list',
                                link: '/client/list',
                                role: 'client.view'
                            },
                            {
                                id: 15,
                                label: 'menuitems.master.customer.create',
                                link: '/client/form',
                                role: 'client.register'
                            }
                        ]
                    },

                    {
                        id: 19,
                        label: 'menuitems.master.partner.text',
                        role: ['partner.view', 'partner.register'],
                        link: '/',
                        color: '#4285f4',
                        bg_active: '#4285f480',
                        subItems: [
                            {
                                id: 20,
                                label: 'menuitems.master.partner.list',
                                link: '/partners',
                                role: 'partner.view'
                            },
                            {
                                id: 21,
                                label: 'menuitems.master.partner.create',
                                link: '/partner/form',
                                role: 'partner.register'
                            }
                        ]
                    },
                    {
                        id: 22,
                        label: 'menuitems.master.employee.text',
                        role: ['employee.view', 'employee.register'],
                        link: '/',
                        color: '#ea4335',
                        bg_active: '#ea433580',
                        subItems: [
                            {
                                id: 23,
                                label: 'menuitems.master.employee.list',
                                link: '/employees',
                                role: 'employee.view'
                            },
                            {
                                id: 24,
                                label: 'menuitems.master.employee.create',
                                link: '/employee/form',
                                role: 'employee.register'
                            }
                        ]
                    }
                ]
            },
            {
                id: 25,
                label: 'menuitems.master.role.text',
                link: '/',
                role: ['permission.view'],
                subItems: [
                    {
                        id: 26,
                        label: 'menuitems.master.role.list',
                        link: '/permission',
                        role: 'permission.view'
                    }
                ]
            },
            {
                id: 28,
                label: 'menuitems.master.faq.text',
                role: ['faq.view', 'faq.register'],
                link: '/',
                subItems: [
                    {
                        id: 29,
                        label: 'menuitems.master.faq.list',
                        link: '/faqs',
                        role: 'faq.view'
                    },
                    {
                        id: 30,
                        label: 'menuitems.master.faq.create',
                        link: '/faq/form',
                        role: 'faq.register'
                    }
                ]
            },
            {
                id: 31,
                label: 'menuitems.master.other.text',
                link: '/master/other',
                role: ['master.register', 'master.edit', 'master.delete', 'master.view'],
                subItems: [
                    {
                        id: 33,
                        label: 'menuitems.master.faq.list',
                        link: '/master/other',
                        role: ''
                    },
                    {
                        id: 34,
                        label: 'menuitems.master.other.holiday',
                        link: '/master/holidays',
                        role: ''
                    },
                    {
                        id: 35,
                        label: 'menuitems.master.other.holiday_year',
                        link: '/master/holiday-year',
                        role: ''
                    },
                    {
                        id: 40,
                        label: 'menuitems.master.other.manual',
                        link: '/master/manual',
                        role: ''
                    },
                    {
                        id: 36,
                        label: 'menuitems.master.other.template',
                        link: '/master/template',
                        role: ''
                    },
                    {
                        id: 37,
                        label: 'menuitems.master.other.rule',
                        link: '/master/rule',
                        role: ''
                    },
                    {
                        id: 38,
                        label: 'menuitems.master.other.rule1',
                        link: '/master/condition-rule',
                        role: ''
                    },
                    {
                        id: 39,
                        label: 'menuitems.master.other.scheduleList',
                        link: '/master/schedule/list',
                        role: ''
                    },
                    {
                        id: 41,
                        label: 'menuitems.master.other.customDomain',
                        link: '/master/custom-domain',
                        role: ''
                    }
                ]
            }
        ]
    },

    {
        id: 150,
        label: 'menuitems.lottery.text',
        role: ['lottery.view', 'lottery.register'],
        icon: 'ri-ticket-2-line',
        subItems: [
            {
                id: 151,
                label: 'menuitems.lottery.list',
                role: 'lottery.view',
                link: '/lottery/list'
            },
            {
                id: 152,
                label: 'menuitems.lottery.create',
                role: 'lottery.register',
                link: '/lottery/create'
            }
        ]
    },

    {
        id: 17,
        label: 'menuitems.system.text',
        role: ['history.view'],
        icon: 'ri-settings-3-line',
        subItems: [
            {
                id: 18,
                label: 'menuitems.system.list.history',
                role: 'history.view',
                link: '/system/history',
                subItems: []
            }
        ]
    }
];
